<template>
  <div class="uk-width-1-2 uk-width-1-3@m cardIngredientes">
    <div class="elementB">
      <img v-bind:src="info[0].img">
      <h2 class="title3">{{info[0].titulo}} </h2>
      <p class="text1 colorCafe">{{info[0].texto}}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Card',
  props: {
    info: Array
  }
}
</script>
<style>
.cardIngredientes{
  padding-top:20px;
}
.cardIngredientes img{
  max-width: 120px;
}
.cardIngredientes h2{
  padding-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/CardBeneficios.vue